import React, { useEffect, useState } from 'react'
import { toast } from 'react-toastify';
import { getGroups } from 'src/services/group-service';
import { IGroup } from 'src/services/types';

interface IProps {
    onChange: (groupId: string) => void;
    label: string;
    defaultWithoutGroup?: boolean;
}

export const GroupFilter = ({ onChange, label, defaultWithoutGroup = false }: IProps) => {
    const [list, setList] = useState<IGroup[]>([]);
    const [itemSelected, setItemSelected] = useState<string>( defaultWithoutGroup ? 'null' : '');

    const fetchList = async () => {
      const res = await getGroups();
      if (res.result === 'ok') {
        setList(res.data);
      } else {
        console.log('error:', res.message);
        toast(res.message, { type: 'error' });
      }
    }
  
    useEffect(() => {
      fetchList();
    }, []);
  
    const handleChange = (e: React.ChangeEvent<HTMLSelectElement>) => {
      const value = e.target.value;
        onChange(value);
        setItemSelected(value);
    }
  
    return (
      <div>
        <div>
          <span className="text-muted">{label}:</span>
        </div>
        <select 
            className={`form-control`}
            name="occupations"
            style={{ width: '220px' }}
            onChange={handleChange}
            value={itemSelected || ''}
        >
            <option value={''} selected={!defaultWithoutGroup && itemSelected === ''}>All Groups</option>
            <option value={'null'} selected={defaultWithoutGroup && itemSelected === 'null'}>Users without group</option>
            {
                list.map((item, index) => (
                    <option key={index} value={item.id}>{item.name}</option>
                ))
            }
        </select>
      </div>
    );
  }
